// extracted by mini-css-extract-plugin
export default {"partnerTableHeader":"MemberPageTable_partnerTableHeader__mYnww","bodyScroll":"MemberPageTable_bodyScroll__xECqd","bttmGap":"MemberPageTable_bttmGap__4nhZ9"};